import { useSelector } from 'store';

const useActiveAccount = () => {
  const accountInContext = useSelector((state) => state.accountInContext);

  return accountInContext.accountRole?.account;
};

export default useActiveAccount;
